<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 22 19">
    <g clip-path="url(#clip0_6892_9094)">
      <path
        d="M18.9234 2.46606H1.8313C0.81798 2.46606 0 3.30531 0 4.34498V16.8711C0 17.9107 0.81798 18.75 1.8313 18.75H18.9234C19.9367 18.75 20.7547 17.9107 20.7547 16.8711V4.34498C20.7547 3.30531 19.9367 2.46606 18.9234 2.46606ZM19.5339 16.8711C19.5339 17.2093 19.2653 17.4974 18.9234 17.4974H1.8313C1.48946 17.4974 1.22087 17.2093 1.22087 16.8711V9.98172H19.5339V16.8711ZM1.22087 6.22389V4.34498C1.22087 3.99425 1.48946 3.71867 1.8313 3.71867H18.9234C19.2653 3.71867 19.5339 3.99425 19.5339 4.34498V6.22389H1.22087Z"
        :class="colorClass"
      />
      <path
        d="M21.7778 5.25C21.7778 7.73528 19.7631 9.75 17.2778 9.75C14.7926 9.75 12.7778 7.73528 12.7778 5.25C12.7778 2.76472 14.7926 0.75 17.2778 0.75C19.7631 0.75 21.7778 2.76472 21.7778 5.25Z"
        fill="#E25862"
      />
      <path
        d="M19.3167 3.21114C19.5982 3.49265 19.5982 3.94905 19.3167 4.23057L18.2973 5.25L19.3167 6.26943C19.5982 6.55095 19.5982 7.00735 19.3167 7.28886C19.0352 7.57038 18.5788 7.57038 18.2973 7.28886L17.2778 6.26943L16.2584 7.28886C15.9769 7.57038 15.5205 7.57038 15.239 7.28886C14.9575 7.00735 14.9575 6.55095 15.239 6.26943L16.2584 5.25L15.239 4.23057C14.9575 3.94905 14.9575 3.49265 15.239 3.21114C15.5205 2.92962 15.9769 2.92962 16.2584 3.21114L17.2778 4.23057L18.2973 3.21114C18.5788 2.92962 19.0352 2.92962 19.3167 3.21114Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9094">
        <rect width="22" height="18" fill="white" transform="translate(0 0.75)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
